var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C6.032 2 2 6.032 2 11C2 15.968 6.032 20 11 20C15.968 20 20 15.968 20 11C20 6.032 15.968 2 11 2ZM11 18.2C7.022 18.2 3.8 14.978 3.8 11C3.8 9.335 4.367 7.805 5.321 6.59L15.41 16.679C14.195 17.633 12.665 18.2 11 18.2ZM16.679 15.41L6.59 5.321C7.805 4.367 9.335 3.8 11 3.8C14.978 3.8 18.2 7.022 18.2 11C18.2 12.665 17.633 14.195 16.679 15.41Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIcon);
export default __webpack_public_path__ + "static/media/NoIcon.011a5fa0a6b94e9b7d867c7f11573c59.svg";
export { ForwardRef as ReactComponent };